import React, { FC } from 'react';

import { TabPanelProps } from './types';

/**
 * Declarative tab panel - use inside `<Tabs>`. Props are read by the parent;
 * only `children` are rendered when the panel is active.
 */
const TabPanel: FC<TabPanelProps> = ({ children }) => <>{children}</>;

TabPanel.displayName = 'TabPanel';

export default TabPanel;
